import { ListSearchForm } from '@/types/Shinsei'
import { defineStore } from 'pinia'
import OptionConst from '@/const/Option'
import ShinseiOptionConst from "@/const/Shinsei/Option";

export const useShinseiStore = defineStore('Shinsei', {
  state: () => {
    return {
      item: {
        shinseiStatus: OptionConst.SYOUNIN_STATUS.WAIT,
        syuugyouBasyoId: null,
        name: null,
        staffCode: null,
        shinseiTargetDate: null,
        shinseiTargetMonth: null,
        // zangyouFlg: false,
        shinseiType: OptionConst.SHINSEI_CODE.JIKANGAI,
        searchStatus: ShinseiOptionConst.SEARCH_STATUS.NEED_SYOUNIN,
      } as ListSearchForm,
    }
  },
  actions: {
    // 検索条件のセット
    async setItem(searchItem: ListSearchForm) {
      this.item = searchItem
      console.log('set Shinsei_item-> ', this.item)
    },
    // 検索条件のクリア
    async clear() {
      this.item = {
        shinseiStatus: OptionConst.SYOUNIN_STATUS.WAIT,
        syuugyouBasyoId: null,
        name: null,
        staffCode: null,
        shinseiTargetDate: null,
        shinseiTargetMonth: null,
        // zangyouFlg: false,
        shinseiType: OptionConst.SHINSEI_CODE.JIKANGAI,
        searchStatus: ShinseiOptionConst.SEARCH_STATUS.NEED_SYOUNIN
      };
    }
  },
  getters: {
    searchItem(): ListSearchForm {
      return this.item
    },
  }
})
